import {createFileRoute} from '@tanstack/react-router';
import {StatementPaymentConnectedAccountCallbackPage} from 'features/statement-payment/pages/StatementPaymentConnectedAccountCallbackPage';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/callback/connected-account',
)({
  component: RouteComponent,
  validateSearch: (search) => {
    return {
      status: search.status as string | undefined,
    };
  },
});

function RouteComponent() {
  return <StatementPaymentConnectedAccountCallbackPage />;
}
